import { gql } from "@apollo/client";

export const GET_INVITE_TOKEN = gql`
  query GetInviteToken($input: GetInviteTokenInput!) {
    getInviteToken(input: $input) {
      id
      token
    }
  }
`;

export const REFRESH_INVITE_TOKEN = gql`
  mutation RefreshInviteToken($input: RefreshInviteTokenInput!) {
    refreshInviteToken(input: $input) {
      id
      token
    }
  }
`;

export const DELETE_INVITE_TOKEN = gql`
  mutation DeleteInviteToken($input: DeleteInviteTokenInput!) {
    deleteInviteToken(input: $input) {
      success
    }
  }
`;
